/**
 * Guarda contra a linha `Fontes: —` que o modelo escreve ao fim de um turno
 * SEM consulta (o prompt exige a linha "Fontes:" em toda resposta; num turno
 * só de texto ele preenche com um traço — visto ao vivo em 15/09/2026:
 * "Enviei um novo formulário… Fontes: —"). O conserto de verdade é a regra
 * no prompt do backend; aqui só se evita mostrar um rótulo sem conteúdo.
 *
 * Corta APENAS a ÚLTIMA linha, e só quando ela é "Fontes:" seguida de nada
 * ou de um traço (—, –, -). "Fontes: carteira (62 registros)" fica intacta;
 * uma linha "Fontes:" no MEIO do texto também (falha segura, como
 * `anexos-da-mensagem`).
 */
const LINHA_DE_FONTES_VAZIA = /(?:\r?\n)*[ \t]*Fontes:[ \t]*[—–-]?[ \t]*$/

export function semLinhaDeFontesVazia(texto) {
  if (typeof texto !== 'string' || !texto) return texto || ''
  return texto.replace(LINHA_DE_FONTES_VAZIA, '')
}
